import * as React from 'react';
import { DisplayTextWithLinks } from 'ui/common/display-text-with-links';
import { Expandable, ShouldTruncate } from 'ui/expandable';
import { AdministrationMessagesTranslation } from '../../constants';
import styles from './expandable-message.scss';

const visibleTextLength = 200;

export interface ExpandableMessageProps {
  message: string;
  translation: AdministrationMessagesTranslation;
}

export const ExpandableMessage: React.FC<ExpandableMessageProps> = ({
  message = '', translation
}) => {

  const contentRender = (collapsed: boolean): React.ReactNode => {
    const visibleText = collapsed ? message.substring(0, visibleTextLength) : message;
    return <DisplayTextWithLinks text={visibleText + (collapsed ? '...' : '')} />;
  };

  const shouldTruncate = ShouldTruncate(message, visibleTextLength);

  return message
    ? <>
      {shouldTruncate ?
        <div className={styles.expandableTextPrintOnly}>
          {message}
        </div>
        : null
      }
      <div className={`${styles.inlineText} ${styles.expandableText}`}>
        {shouldTruncate ?
          <Expandable content={contentRender}
            textDisplayMore={translation.show_more}
            textDisplayLess={translation.show_less}
            useMargin={false} />
          : <DisplayTextWithLinks text={message} />
        }
      </div>
    </>
    : null;
};
